import { render, staticRenderFns } from "./lopperList.vue?vue&type=template&id=479f4ccb"
import script from "./lopperList.vue?vue&type=script&lang=js"
export * from "./lopperList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports